var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEventBusyBlack24Dp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24.4 25.4",
    style: {
      enableBackground: "new 0 0 24.4 25.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#BE1212;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0h24v24H0V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.1,19.4l2.7-2.8l2.7,2.8l1.2-1.3l-2.7-2.8l2.7-2.8l-1.1-1.3L12,14.1l-2.8-2.8l-1.2,1.3l2.7,2.8l-2.7,2.8 L9.1,19.4z M20.1,3.3H19V1h-2.3v2.3H7.7V1H5.4v2.3H4.3C3,3.3,2,4.3,2,5.6v16.1C2,23,3,24,4.3,24h15.8c1.2,0,2.3-1,2.3-2.3V5.6 C22.4,4.3,21.3,3.3,20.1,3.3z M20.1,21.7H4.3V9.1h15.8V21.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventBusyBlack24Dp);
export default __webpack_public_path__ + "static/media/event_busy_black_24dp.58c045c9f620cc14a9428b8c902d0b7d.svg";
export { ForwardRef as ReactComponent };